import moment from 'moment';
import React, { Component, Fragment } from 'react';
import DatePicker from 'react-datepicker';
import { Input, FormField } from 'semantic-ui-react';
import Field from './Field';
import TimeInput from './TimeInput';
import yup from 'yup';

const splitToDateAndTime = date => ({
  date: date ? moment.utc(date, 'YYYY-MM-DD') : undefined,
  time: date
    ? moment.utc(date, 'YYYY-MM-DDTHH:mm:ss').format('HH:mm')
    : undefined
});
const mergeDateAndTime = (date, time) => {
  if (!date || !time) return undefined;
  return moment(date)
    .hours(time.slice(0, 2))
    .minutes(time.slice(-2))
    .format('YYYY-MM-DDTHH:mm:ss');
};

const noUTC = date =>
  moment.utc(date, 'YYYY-MM-DDTHH:mm:ss').format('YYYY-MM-DDTHH:mm:ss');

class DateAndTimeInputs extends Component {
  constructor(props) {
    super(props);
    const { date, time } = splitToDateAndTime(props.value);
    this.state = { date, time };
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.value !== nextProps.value && nextProps.value !== undefined) {
      const { date, time } = splitToDateAndTime(nextProps.value);
      this.setState({ date, time });
    }
  }

  setDate = date => {
    this.setState({ date }, () => {
      if (this.state.time) this.setFieldValue();
    });
  };

  setTime = time => {
    this.setState({ time }, () => {
      if (this.state.date) this.setFieldValue();
    });
  };

  setFieldValue = () => {
    const { setFieldValue, name } = this.props;
    const { date, time } = this.state;

    setFieldValue(name, mergeDateAndTime(date, time));
  };

  render = () => {
    const { date, time } = this.state;
    const { errors, touched, text, inputWidth, disabled } = this.props;
    return (
      <Fragment>
        <Field error={errors} touched={touched} width={inputWidth || 2}>
          <FormField
            className="c-DatePicker__wrapper c-DatePicker__wrapper--filters"
            disabled={disabled}
          >
            <label>{text} Date</label>
            <DatePicker
              dateFormat="DD/MM/YYYY"
              placeholderText={`${text} Date`}
              selected={date}
              onChange={this.setDate}
              isClearable={true}
              showMonthDropdown
              showYearDropdown
              customInput={<Input style={{ width: '100%' }} />}
            />
          </FormField>
        </Field>
        <Field error={errors} touched={touched} width={inputWidth || 2}>
          <FormField
            className="c-DatePicker__wrapper c-DatePicker__wrapper--filters"
            disabled={disabled}
          >
            <label>{text} Time</label>
            <TimeInput
              placeholder={`${text} Time`}
              onTimeChange={this.setTime}
              initTime={time}
            />
          </FormField>
        </Field>
      </Fragment>
    );
  };
}

function notEqual(ref, msg) {
  return yup.mixed().test({
    name: 'notEqual',
    exclusive: false,
    //eslint-disable-next-line
    message: msg || '${path} cannot be the same as ${reference}',
    params: {
      reference: ref.path
    },
    test: function(value) {
      return value === undefined || value !== this.resolve(ref);
    }
  });
}

export { noUTC, notEqual };
export default DateAndTimeInputs;



// WEBPACK FOOTER //
// ./src/component/DateAndTimeInputs.js